import React from 'react'
import PropTypes from 'prop-types'
import { utils, translate, ui } from 'parking-react-common'
import { connect } from 'react-redux'

import { compact, map } from 'lodash'

import List from '../components/List'
import Label from '../components/Label'
import TZDateTime from './TZDateTime'
import ListTotals from './ListTotals'

import { externalSessions, users, parkingLots, filters } from '../redux'

const ExternalSessionsList = ({ title, subtitle, dataURL, dataSelector, showParkingLot, t }) => {
    const columns = compact([
        {
            key    : 'parked_from',
            title  : t('Parked From'),
            render : ({ cellData }) => ( // eslint-disable-line react/prop-types
                <TZDateTime input={ cellData } />
            )
        },
        {
            key   : 'duration',
            title : t('Duration'),
            parse : ({ rowData }) => externalSessions.getDuration(rowData),
            total : (data) => utils.sumTimes(map(data, 'duration'))
        },
        {
            key    : 'amount_paid',
            title  : t('Paid'),
            parse  : ({ cellData }) => parseFloat(cellData),
            render : ({ cellData, rowData }) => utils.formatAmountWithUnit(cellData, rowData.currency),
            total  : (data) => <ListTotals field="amount_paid" unitField="currency" data={ data } />
        },
        {
            key   : 'license_plate',
            title : t('Vehicle')
        },
        showParkingLot && {
            key   : 'parking_lot.name',
            title : t('Parking lot')
        },
        {
            key    : 'active',
            title  : 'Status',
            render : ({ cellData }) => ( // eslint-disable-line react/prop-types
                cellData
                    ? <Label intent={ ui.INTENT.success } text={ t('ACTIVE') } />
                    : <Label intent={ ui.INTENT.primary } text={ t('CLOSED') } />
            )
        }
    ])

    const searchKeys = ['license_plate', 'amount_paid', 'parking_lot.name', ...users.getSearchKeys()]
    const filterKeys = {
        parked_from: filters.TYPES.dateRange
    }

    return (
        <List
            title={ title }
            subtitle={ subtitle }
            columns={ columns }
            dataURL={ dataURL }
            dataSelector={ dataSelector }
            searchKeys={ searchKeys }
            filterKeys={ filterKeys }
            sortBy="parked_from"
            isDownloadable
        />
    )
}

ExternalSessionsList.propTypes = {
    title          : PropTypes.node,
    subtitle       : PropTypes.node,
    dataSelector   : PropTypes.func,
    dataURL        : PropTypes.string,
    showParkingLot : PropTypes.bool
}

ExternalSessionsList.defaultProps = {
    title          : 'External Sessions',
    dataSelector   : externalSessions.getAll,
    dataURL        : 'externalSessions',
    showParkingLot : false
}

function mapStateToProps(state, ownProps) {
    const dataSelector = (state) => {
        const externalSessions = ownProps.dataSelector(state)
        return utils.enhance(externalSessions, {
            user        : ({ user }) => users.getForID(user)(state),
            // eslint-disable-next-line camelcase
            parking_lot : ({ parking_lot }) => parkingLots.getForID(parking_lot)(state)
        })
    }

    return {
        dataSelector
    }
}

export default translate()(connect(mapStateToProps)(ExternalSessionsList))
